// setupRUM.ts
import { AwsRum, AwsRumConfig } from 'aws-rum-web';

const setupRUM = () => {
  try {
    const config: AwsRumConfig = {
      signing: false,
      sessionSampleRate: 1,
      sessionEventLimit: 0,
      endpoint: process.env.REACT_APP_RUM_ENDPOINT || "https://dataplane.rum.us-west-1.amazonaws.com",
      telemetries: ["errors","http"],
      allowCookies: true,
      enableXRay: false
    };
    const APPLICATION_ID = process.env.REACT_APP_RUM_APPLICATION_ID || '';
    const APPLICATION_VERSION = process.env.REACT_APP_RUM_APPLICATION_VERSION || '';
    const APPLICATION_REGION = process.env.REACT_APP_RUM_APPLICATION_REGION || '';

    // No monitor, no RUM. The endpoint above defaults to a real AWS dataplane
    // when REACT_APP_RUM_ENDPOINT is blank, and AwsRum posts happily with an
    // empty application id — so a build that means to have RUM switched off
    // (the e2e build, .env.e2e) was sending telemetry to AWS on every page
    // load. Callers read window.AWSRum optionally, so leaving it unset is safe.
    if (!APPLICATION_ID) {
      return;
    }

    const awsRum: AwsRum = new AwsRum(
      APPLICATION_ID,
      APPLICATION_VERSION,
      APPLICATION_REGION,
      config
    );

    (window as any).AWSRum = awsRum;

  } catch (error) {
    // Ignore errors thrown during CloudWatch RUM web client initialization
    console.error("Error initializing CloudWatch RUM:", error);
  }
};

export default setupRUM;
